import React, { useEffect, useState } from "react"
import moment from "moment"
import { fetchBedAppointments } from "../../core/services/api/bedManagementService"
import AppointmentCalendarUtils from "../AppointmentCalendar/AppointmentCalenderUtils"
import CalendarPicker from "../AppointmentCalendar/components/CalendarPicker"
import PatientChip from "../AppointmentCalendar/components/PatientChip"
import "./NurseCalendar.scss"
import { MocUserRole } from "core/services/models/Enums"

export default function NurseCalendar({
  centerDetail, userDetail, onPatientChipButtonClick, userRole, show, updateSelectedItemMain
}: any) {

  const [slots, updateSlots] = useState<any>()
  const [rooms, updateRooms] = useState<any>()

  const [selectedItem, updateSelectedItem] = useState<any>()
  const [displayString, updateDisplayString] = useState<any>()

  useEffect(() => {
    updateSelectedItemMain(selectedItem)
  }, [selectedItem])

  useEffect(() => {
    if (centerDetail) {
      let temp = moment().format("YYYY-MM-DD")
      updateSelectedItem(temp)

      let tempSlots = AppointmentCalendarUtils.createTimeSlots(
        centerDetail?.openTime,
        centerDetail?.closeTime,
        centerDetail?.bedSlotDuration
      )
      updateSlots(tempSlots)
    }
  }, [centerDetail])

  useEffect(() => {
    if (selectedItem) {
      let displayString = AppointmentCalendarUtils.renderSelectedItem(
        "Day",
        selectedItem
      )
      updateDisplayString(displayString)

      fetchBedAppointments(userDetail?.currentCenter?.centerId, selectedItem)
        .then((res: any) => {
          if (userRole === MocUserRole.NURSE) {
            const filteredRes = res.map((item: any) => {
              const filteredBeds = item.beds.map((bed: any) => ({
                ...bed,
                bookedBedsList: bed.bookedBedsList.filter((ele: any) => ele.bedBookingStatus !== "CANCELLED")
              }));

              return {
                ...item,
                beds: filteredBeds
              };
            });

            updateRooms(filteredRes);
          } else {
            updateRooms(res);
          }
        })
        .catch((err: any) => console.log("err in fetch bed appointment", err));

    }
  }, [selectedItem])



  function renderBedHeaderSection(eachRoom: any) {
    return (
      <div
        key={eachRoom?.id}
        className="room-wrapper"
        style={{
          gridColumn: eachRoom?.beds?.length > 1 ? `span ${eachRoom?.beds?.length}` : "span 1",
        }}
      >
        <div className={`room-detail`}>
          <div className="bed">{eachRoom?.roomName}</div>

          {eachRoom?.beds?.length > 1 ? (
            <div className="d-flex align-center beds">
              {eachRoom?.beds?.map((eachBed: any) => (
                <div className="col">
                  <div className="bed">{eachBed?.name}</div>
                </div>
              ))}
            </div>
          ) : null}
        </div>

        {eachRoom?.beds?.length > 1 ? (
          <div className="d-flex align-center allocatedBeds">
            {eachRoom?.beds?.sort((a: any, b: any) => a?.name?.toLowerCase()?.localeCompare(b?.name?.toLowerCase()))?.map((eachBed: any) => (
              <div className="col">{renderBed(eachBed)}</div>
            ))}
          </div>
        ) : eachRoom?.beds?.length > 0 ? (
          renderBed(eachRoom?.beds[0])
        ) : null}
      </div>
    )
  }

  function renderBed(eachBed: any) {
    return slots?.map((eachSlot: any) => renderSlot(eachSlot, eachBed))
  }

  function renderEmptyView() {
    return (
      <div className="wrapper">
        <div className="border-line-wrapper" style={{ height: "26px" }}>
          <div className="border-line">{ }</div>
        </div>
      </div>
    )
  }

  function renderSlot(eachSlot: any, eachBed: any) {
    let currentSlot = moment(eachSlot, "hh:mm a").format("HH:mm")
    const allocatedBed = eachBed?.bookedBedsList?.find(
      (each: any) =>
        each?.bookedSlots &&
        each?.bookedSlots[0] &&
        each?.bookedSlots[0] === currentSlot
    )
    return allocatedBed ? renderAllocation(allocatedBed) : renderEmptyView()
  }

  function renderAllocation(eachAllocation: any) {
        return (
      <div className="patient col">
        <PatientChip
          patient={eachAllocation}
          disablePopup={false}
          height={eachAllocation?.bookedSlots?.length}
          outline={true}
          userRole={userRole}
          onButtonClick={() => { console.log("inside patient click"); onPatientChipButtonClick(eachAllocation) }}
          slotDuration={centerDetail?.bedSlotDuration}
          handleClick={(evt: any) => console.log('vy', evt)}
          showModal={show}
        />
      </div>
    )
  }

  function getLen() {
    return (
      rooms?.reduce(
        (prev: any, curr: any) => (prev += curr?.beds?.length ?? 0),
        0
      ) ?? 0
    )
  }

  function renderNurseView() {
    return (
      <div className="nurse-view-wrapper">
        <CalendarPicker
          displayString={displayString}
          selectedItem={selectedItem}
          selectedMode={"Day"}
          updateSelectedItem={updateSelectedItem}
          displayModes={false}
        />

        <div className="col-md-12 row m-0">
          <div className="col-1 p-0">
            <div className="empty-space" />
            <div className="time-slot">
              {slots?.map((eachSlot: any) => (
                <div className="timing">{eachSlot}</div>
              ))}
            </div>
          </div>

          <div className="col-11 p-0">
            <div
              className="row m-0 col-12 p-0 header-section"
              style={{
                display: "grid",
                gridTemplateColumns: `repeat(${getLen()}, minmax(100px, 1fr))`,
                overflowX: "auto"
              }}
            >
              {rooms?.sort((a: any, b: any) => a?.roomName?.toLowerCase()?.localeCompare(b?.roomName?.toLowerCase()))?.map((eachRoom: any) => renderBedHeaderSection(eachRoom))}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return renderNurseView()
}
